import SubtopicsContainer from './SubtopicsContainer';

export default { SubtopicsContainer };
